import { createContext, useContext } from "react";
import { Employee } from "../types/employee.types";

interface EmployeeOverviewContextType {
  employee: Employee | null;
}

const EmployeeOverviewContext =
  createContext<EmployeeOverviewContextType | null>(null);

export const useEmployeeOverview = () => {
  const context = useContext(EmployeeOverviewContext);
  if (!context) {
    throw new Error("useEmployeeOverview must be used within provider");
  }
  return context;
};

export default EmployeeOverviewContext;
